// @flow
// $FlowIgnore
import {Factories} from '@wellstone-solutions/common';
import {ContactModel} from '../contact';
import type {FactoryAnswerType, UIAnswerType} from '../../types';

const expirationDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 30);

  return date;
};

export const Factory = (overrides?: FactoryAnswerType): UIAnswerType =>
  Factories.createFactory(
    {
      contacts: [ContactModel.Factory()],
      other: {},
      description: '',
      expires: expirationDate().toISOString(),
      id: '',
      modified: '',
      organizationTitle: '',
      question: {id: ''},
      state: '',
      subtitle: '',
      title: '',
    },
    overrides,
  );
